import { 
    AgentData, 
    DefaultData, 
    SupervisorData,
    ManagerData
} from "../../../visualizations/visualizations";

export function OpalDashboardFactoryComponent(role) {
    switch (role) {
        case 'agent':
            return AgentData;
        case 'supervisor':
            return SupervisorData;
        case 'manager':
            return ManagerData;
        default:
            return DefaultData;
    }
}
